const { StyleSheet } = require("@react-pdf/renderer");

export const globalStyles = StyleSheet.create({
  page: {
    fontSize: 10,
    color: "#333",
    marginVertical: 20,
    paddingHorizontal: 10,
    paddingBottom: 40,
    // marginHorizontal: 10,
  },
  section: {
    flexDirection: 'column',
    // marginVertical: 5,
    // marginHorizontal: 10,
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  fontBold: {
    fontFamily: "Helvetica-Bold"
  },
  standardBorder: {
    border: "1px solid #ddd"
  },
  reportHeading: {
    textTransform:"uppercase",
    fontFamily: "Helvetica-Bold",
    fontSize: "11px",
    marginTop: "10px",
  },
  textInput: {
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    backgroundColor: "#eee",
  },
  tableCommon: {
    border: "1px solid #ddd",
    backgroundColor: "#fff"
  },
  tHeadCommon: {
    padding: "5 10",
    fontFamily: "Helvetica-Bold",
  },
  tColCommon: {
    padding: 10,
  },
  table: {
    flexDirection: "column"
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #ddd",
    paddingVertical: "5px",
  },
  tableHead: {
    fontFamily: "Helvetica-Bold",
    width: "25%",
    // border: "1px solid #ddd",
  },
  tableColumn: {
    width: "25%",
    // border: "1px solid #ddd"
  },
  reportQuestionOuter: {
    paddingVertical: "10px"
  },
  reportQuestion: {
    fontFamily: "Helvetica-Bold",
    marginBottom: "5px"
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 20,
    fontSize: 9,
    fontStyle: "italic"
  },
  footerContainer: {
    fontSize: 8,
    position: 'absolute',
    bottom: 5,
    left: 0,
    right: 0,
  },
  imgIcon: {
    width: 22,
    height: 20
  }
})